export default __webpack_public_path__ + "static/media/ResearchAI Demo.1d7a6384.mp4";